import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import FeatureHighlight from '../../components/cultivars/FeatureHighlight';
import ProductShowcase from '../../components/cultivars/Blackberrymoonrocks/ProductShowcase';
import CultivarDisplay from '../../components/cultivars/CultivarDisplay';
import Cta from '../../components/Cta';

const Blackberrymoonrocks = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Blackberry Moonrocks Cultivar - BeyondBloom™</title>
        <meta name="description" content="Explore Blackberry Moonrocks, a premium cultivar from BeyondBloom™. Experience exceptional quality, flavor, and potency in every bloom." />
        <meta name="keywords" content="Blackberry Moonrocks, cultivar, BeyondBloom, premium plants, greenhouse, high potency" />
        <meta name="author" content="BeyondBloom™" />
        <meta property="og:title" content="Blackberry Moonrocks Cultivar - BeyondBloom™" />
        <meta property="og:description" content="Explore Blackberry Moonrocks, a premium cultivar from BeyondBloom™. Experience exceptional quality, flavor, and potency in every bloom." />
        <meta property="og:image" content="/images/blackberry-moonrocks.png" />
        <meta property="og:url" content="https://yourwebsite.com/blackberry-moonrocks" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Blackberry Moonrocks Cultivar - BeyondBloom™" />
        <meta name="twitter:description" content="Explore Blackberry Moonrocks, a premium cultivar from BeyondBloom™. Experience exceptional quality, flavor, and potency in every bloom." />
        <meta name="twitter:image" content="/images/blackberry-moonrocks.png" />
      </Helmet>

      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default Blackberrymoonrocks;
